module.exports = __webpack_public_path__ + "static/media/underline.6cb79f6c.svg";